import { produce } from 'immer';
import { CURRENT_USER_LOADED, TOKEN_OBTAINED } from './current-user.actions';
import { IUser } from '../../domain/user.interface';

export const initialState: { currentUser: IUser; token: string } = {
  currentUser: {
    id: '',
    name: '',
    nickname: '',
    email: '',
    isOfLegalAge: undefined,
    legalConditionsAccepted: undefined,
    userPhoto: '',
  },
  token: '',
};

export const currentUserReducer = (state = initialState, action: any) =>
  produce(state, draft => {
    switch (action.type) {
      case CURRENT_USER_LOADED:
        draft.currentUser = action.payload;
        return;
      case TOKEN_OBTAINED:
        draft.token = action.payload;
        return;
    }
  });
